import Context from './PlayerColorContext';
import Provider from './PlayerColorProvider';

export default {
  Consumer: Context.Consumer,
  Context,
  Provider,
};
